// 外部リンクを別タブで開く
document.addEventListener("DOMContentLoaded", (event) => {
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const buttonWrappers = document.querySelectorAll('.add-button-wrapper');

  buttonWrappers.forEach(wrapper => {
    wrapper.addEventListener('click', (event) => {
      const button = wrapper.querySelector('button');
      const alertMessage = wrapper.dataset.alertMessage;

      // ボタンが無効化されている場合はアラートを表示
      if (button.hasAttribute('disabled')) {
        event.preventDefault();
        window.alert(alertMessage);
      }
    });
  });
});